import { render, staticRenderFns } from "./u-tit-subtit.vue?vue&type=template&id=65c5d692&scoped=true"
import script from "./u-tit-subtit.vue?vue&type=script&lang=js"
export * from "./u-tit-subtit.vue?vue&type=script&lang=js"
import style0 from "./u-tit-subtit.vue?vue&type=style&index=0&id=65c5d692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c5d692",
  null
  
)

export default component.exports